<navbar (sendUserNotificationToContactInfoEvent)="sendUserNotificationToContactInfo($event)" [@.disabled]="navAnimationDisabled" [@slideNav] *ngIf="hideNav == false" (changeSlide)="changeSlide($event)"></navbar>

<div class="main-dashboard-background-container ">
  <div class="main-dashboard-container safe-area safe-area-with-nav"     
      [ngClass]="{'main-sidenav-hidden': labService.currentSelectedLab == null || enableSideNav == false}"
  >
    

  <!-- Debug buttons removed - issue fixed -->
  <dashboard-sidenav
  #dashboardSidenav
  [ngClass]="{'main-sidenav-visible': labService.currentSelectedLab != null && enableSideNav}"
  (changeSlideEvent)="changeSlide($event)"
  (reestablishBackButtonEvent)="reestablishBackButtonHandler()"
  [currentMainSliderSection]="selectedMainSliderSection"
  ></dashboard-sidenav>

    <div class="swiper-parent-container"
      [ngClass]="{'main-sidenav-hidden': labService.currentSelectedLab == null || enableSideNav == false}"
    >
      <swiper-container #mainSwiper [simulateTouch]="false" [allowTouchMove]="false" [loop]="false"
      [observer]="true"
      [observeParents]="true"
  
    >
  
      <swiper-slide>
        <labs-list *ngIf="initialRender || forceMainRenders || (selectedMainSliderSection == MainSliderSection.LABS || transitioningSlideIndex == MainSliderSection.LABS)" #labsListComponent (changeSlideEvent)="changeSlide($event)" class="chats" [initialRender]="initialRender" ></labs-list>
      </swiper-slide>
  
      <swiper-slide>
        <app-resources *ngIf="initialRender || forceMainRenders || (selectedMainSliderSection == MainSliderSection.RESOURCES || transitioningSlideIndex == MainSliderSection.RESOURCES)" class="resources" [initialRender]="initialRender"></app-resources>
      </swiper-slide>
  
      <swiper-slide>
        <contacts *ngIf="initialRender || forceMainRenders || (selectedMainSliderSection == MainSliderSection.CONTACTS || transitioningSlideIndex == MainSliderSection.CONTACTS)" #contactsComponent class="contacts" (changeSlideEvent)="changeSlide($event)" (selectedContactEvent)="selectedContact($event)" (enableSlider)="enableSlider()" (disableSlider)="disableSlider()" ></contacts>
      </swiper-slide>
  
      <swiper-slide>
        <contact-info *ngIf="initialRender || (selectedMainSliderSection == MainSliderSection.CONTACTINFO || transitioningSlideIndex == MainSliderSection.CONTACTINFO)"  #contactInfoComponent  (changeSlideEvent)="changeSlide($event)" (contactRequestProcessed)="onContactRequestProcessed()" [initialRender]="initialRender" [userNotificationContactRequest]="userNotificationContactRequest" ></contact-info>
      </swiper-slide>
  
      <!-- Code BL slide -->
      <swiper-slide class="swiper-with-nav">
        <app-code-bl *ngIf="initialRender || forceMainRenders || (selectedMainSliderSection == MainSliderSection.CODEBL || transitioningSlideIndex == MainSliderSection.CODEBL)"></app-code-bl>
      </swiper-slide>
  
      <swiper-slide class="swiper-with-nav">
        <lab #labComponent 
          [hidden]="selectedMainSliderSection != MainSliderSection.LAB && transitioningSlideIndex != MainSliderSection.LAB || !labService.currentSelectedLab" 
          (changeMainSlide)="changeSlide($event)" 
          (exitComponent)="changeSlide(MainSliderSection.LABS)" 
          [initialRender]="initialRender" >
        </lab>
      </swiper-slide>

     
  
      <swiper-slide class="swiper-with-nav">
        <gadget #gadgetComponent 
          [hidden]="selectedMainSliderSection != MainSliderSection.GADGET && transitioningSlideIndex != MainSliderSection.GADGET" 
          (changeMainSlide)="changeSlide($event)" 
          (exitComponent)="changeSlide(MainSliderSection.LAB)" 
          [initialRender]="initialRender"
        ></gadget>
      </swiper-slide>
  
      <swiper-slide class="swiper-with-nav">
        <gadget-component  
          #gadgetComponentComponent 
          [initialRender]="initialRender" 
          (setConfirmSlideChangeCallback)="setConfirmSlideChangeCallback($event)" 
          [hidden]="(selectedMainSliderSection != MainSliderSection.COMPONENT && transitioningSlideIndex != MainSliderSection.COMPONENT)" 
          (changeMainSlide)="changeSlide($event)" 
          (exitComponent)="changeSlide(MainSliderSection.GADGET)"
        ></gadget-component>
      </swiper-slide>

      <swiper-slide class="swiper-with-nav">
        <lab-controller [initialRender]="initialRender" *ngIf="initialRender || (selectedMainSliderSection == MainSliderSection.CONTROLLER || transitioningSlideIndex == MainSliderSection.CONTROLLER)"></lab-controller>
      </swiper-slide>

      <swiper-slide class="swiper-with-nav">
        <lab-user-list [initialRender]="initialRender" [labComplete]="labService.currentSelectedLab" *ngIf="false && initialRender || (selectedMainSliderSection == MainSliderSection.LABUSERS || transitioningSlideIndex == MainSliderSection.LABUSERS)"></lab-user-list>
      </swiper-slide>
  
      <swiper-slide class="swiper-with-nav">
        <lab-settings *ngIf="false && (selectedMainSliderSection == MainSliderSection.LABSETTINGS || transitioningSlideIndex == MainSliderSection.LABSETTINGS)" [initialRender]="initialRender"></lab-settings>
      </swiper-slide>

      
    </swiper-container>
    </div>
   

  </div>
  
</div>



